import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { EInvoicingBannerComponent } from './e-invoicing-banner.component';

@NgModule({
  declarations: [EInvoicingBannerComponent],
  exports: [EInvoicingBannerComponent],
  imports: [CommonModule, NgxBootstrapIconsModule],
})
export class EInvoicingBannerModule {}
